var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitsPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9ed32;}.cls-1,.cls-12,.cls-7{opacity:0.5;}.cls-2{fill:#febe10;}.cls-3{fill:#00a0df;}.cls-4{fill:#0072b2;}.cls-5,.cls-6{opacity:0.75;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:url(#linear-gradient-2);}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:#1046fe;}.cls-9{fill:#386af9;}.cls-10{fill:#5735aa;}.cls-11{fill:#ffaed9;}.cls-13{fill:#ff75b0;}.cls-14{fill:#ff4a4a;}.cls-15{fill:#fff;}.cls-16{fill:#e6e7e8;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 277.94,
    y1: 358.98,
    x2: 277.94,
    y2: 43.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffbc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fffbc7",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fffbcc",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fffcd5",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fffde1",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#fffef0",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -724.84,
    y1: 360.21,
    x2: -724.84,
    y2: 44.69,
    gradientTransform: "matrix(-1, 0, 0, 1, -504.03, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffbc5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fffbc7",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fffccd",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fffcd6",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#fffde2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fffef2",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 249.31,
    y1: 49.59,
    x2: 249.31,
    y2: 320.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#fffef2",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#fffde2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#fffcd6",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fffccd",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fffbc7",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffbc5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3_copy",
    "data-name": "Layer 3 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,303.92c66.37,21,120.12,24.81,155.83,24.67,96.17-.36,139.25-32.52,214.81-18.8,38,6.9,82.57,24.86,129.36,66.72V1.62H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,295c28.83,9.46,75.9,21.41,133.06,18.45,101.91-5.28,144.48-53.22,230.87-48.84,31.57,1.6,79.14,10.7,136.07,49.92V1.62H0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.64,225.22l-109.17,43L150,359.49a3.84,3.84,0,0,0,5.05,3.2L248.64,331Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M248.64,225,357.8,268,347.29,355.2a7.27,7.27,0,0,1-9.57,6l-89.08-30.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.47,268.17l109.17-43-21.57-27.3L127,233.25a2.46,2.46,0,0,0-1.44,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M357.8,268.17l-109.16-43,21.56-27.3,100.12,35.33a2.46,2.46,0,0,1,1.44,3.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M248.8,229c-.63,14-1.16,84.38-.21,96.58C249.1,312,249.43,229,248.8,229Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M251.17,228.23c14.26,5.15,99.71,39.28,99.44,39.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M245.25,226.91c-14.25,5.14-99.7,39.28-99.44,39.94"
  }), /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "130.64 43.36 425.24 43.36 314.67 358.98 186.97 358.98 130.64 43.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "366.4 44.69 75.21 44.69 181.28 358.98 312.79 360.2 366.4 44.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "327.28 49.59 171.34 49.59 195.58 320.21 299.95 320.21 327.28 49.59"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M388.88,238.73l-112.1,36.62-28.14,30.33v-.11l-.21-.07-28-30.15L108.35,238.73l31.12,29.44v.32l10.44,90.41a8.85,8.85,0,0,0,5.6,7.24l90.58,35a8.42,8.42,0,0,0,6.11,0l89.11-35.06a8.85,8.85,0,0,0,5.54-7.16l10.95-90.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M243.7,304.81c-14.91-4.54-88.68-30.05-101.08-35.56C157.08,273.77,243.94,304.14,243.7,304.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M254.23,304.05c14.91-4.54,88.68-30,101.09-35.56C340.85,273,254,303.39,254.23,304.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M248.8,309.35c-.51,12.59-.66,75.72.26,86.68C249.46,383.78,249.38,309.35,248.8,309.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "346.22 161.73 313.38 182.6 327.68 218.8 288.82 216.36 279.15 254.07 249.15 229.24 219.15 254.07 209.47 216.36 170.62 218.8 184.92 182.6 152.07 161.73 184.92 140.85 170.62 104.66 209.47 107.09 219.15 69.39 249.15 94.21 279.15 69.39 288.82 107.09 327.68 104.66 313.38 140.85 346.22 161.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M285.16,213l-4.29-26.57-.17-1-.83-5.15-1.81-11.18-.13-.85L271.11,126a7.11,7.11,0,0,0-4.39-5.45L246,112.12l-3-1.21,1.45.58-5-4.37-.46-.41-2.21-1.93-7.48.56-.13-.06-.27-.09-.25-.08-.06,0-.28-.08h-.07l-.23-.06-.17,0h0l-.32-.06c-.22,0-.43,0-.66-.06h-.34a7.62,7.62,0,0,0-4.92,1.8l-2.24,1.92-1.16,1-2.44,2.09.55.49-7.39,6.3c-.18-.17-.35-.33-.52-.51h0l-17.53,15a7.1,7.1,0,0,0-2.45,6.55l14,87a7.29,7.29,0,0,0,8.44,5.9L232,228.83l10.44-1.68.47-.08L279,221.24l.29-.05a7.41,7.41,0,0,0,3.82-2A7,7,0,0,0,285.16,213Zm-65.5-92.74a8.67,8.67,0,0,1,2.24-3.78s0,0,0,0a7.84,7.84,0,0,1,.61-.54,8.54,8.54,0,0,1,3.26-1.66l.25-.06a5.6,5.6,0,0,1,.59-.12,6.2,6.2,0,0,1,.74-.08h.08a8.73,8.73,0,0,1,8.36,4.78l0,.09c0,.09.09.18.13.27a2.29,2.29,0,0,1,.1.23l.09.23q.13.34.24.72c0,.1.06.21.08.31s.1.45.14.68a8.65,8.65,0,0,1-.28,4,8.09,8.09,0,0,1-.38,1l0,.08-.14.3-.1.18-.08.15-.14.23a9.92,9.92,0,0,1-.91,1.24l-.21.22-.18.19c-.19.19-.39.37-.59.54l-.18.15a9,9,0,0,1-.81.56l-.18.11-.15.08a7.14,7.14,0,0,1-.73.37l-.5.2-.26.09-.27.08-.27.08a7.45,7.45,0,0,1-.82.17l-.1,0a8.72,8.72,0,0,1-9.67-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M285.16,213l-4.29-26.57-.17-1-.83-5.15-1.81-11.18-.13-.85L271.11,126a7.11,7.11,0,0,0-4.39-5.45L246,112.12l-3-1.21,1.45.58-5-4.37-.46-.41-2.21-1.93-7.48.56-.13-.06-.27-.09-.25-.08-.06,0-.28-.08h-.07l-.23-.06-.17,0h0l-.32-.06c-.22,0-.43,0-.66-.06h-.34a7.62,7.62,0,0,0-4.92,1.8l-2.24,1.92-1.16,1-2.44,2.09.55.49-7.39,6.3c-.18-.17-.35-.33-.52-.51h0l-17.53,15a7.1,7.1,0,0,0-2.45,6.55l14,87a7.29,7.29,0,0,0,8.44,5.9L232,228.83l10.44-1.68.47-.08L279,221.24l.29-.05a7.41,7.41,0,0,0,3.82-2A7,7,0,0,0,285.16,213Zm-65.5-92.74a8.67,8.67,0,0,1,2.24-3.78s0,0,0,0a7.84,7.84,0,0,1,.61-.54,8.54,8.54,0,0,1,3.26-1.66l.25-.06a5.6,5.6,0,0,1,.59-.12,6.2,6.2,0,0,1,.74-.08h.08a8.73,8.73,0,0,1,8.36,4.78l0,.09c0,.09.09.18.13.27a2.29,2.29,0,0,1,.1.23l.09.23q.13.34.24.72c0,.1.06.21.08.31s.1.45.14.68a8.65,8.65,0,0,1-.28,4,8.09,8.09,0,0,1-.38,1l0,.08-.14.3-.1.18-.08.15-.14.23a9.92,9.92,0,0,1-.91,1.24l-.21.22-.18.19c-.19.19-.39.37-.59.54l-.18.15a9,9,0,0,1-.81.56l-.18.11-.15.08a7.14,7.14,0,0,1-.73.37l-.5.2-.26.09-.27.08-.27.08a7.45,7.45,0,0,1-.82.17l-.1,0a8.72,8.72,0,0,1-9.67-11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M285.16,213l-4.29-26.57-.17-1-.83-5.15-1.81-11.18-.13-.85L271.11,126a7.11,7.11,0,0,0-4.39-5.45L246,112.12l-3-1.21-.31-.13-.78-.31-3-1.2-4.35-1.77-1.75-.71-.31-.13-3.26-1.32-.13-.06-.27-.09-.25-.08-.06,0-.28-.08h-.07l-.23-.06-.17,0h0l-.32-.06c-.22,0-.43,0-.66-.06h-.34a7.62,7.62,0,0,0-4.92,1.8l-2.24,1.91h0l-1.16,1-2.44,2.09-.42.35-7,5.93h0l-17.53,15a7.1,7.1,0,0,0-2.45,6.55l14,87a7.29,7.29,0,0,0,8.44,5.9L232,228.83l10.44-1.68.47-.08L279,221.24l.29-.05a7.41,7.41,0,0,0,3.82-2A7,7,0,0,0,285.16,213Zm-65.5-92.74a8.67,8.67,0,0,1,2.24-3.78s0,0,0,0a1.84,1.84,0,0,1,.52-.23,13.81,13.81,0,0,1,3.25-.35c3.75,0,9,.7,10.12,2.89l0,.09c0,.09.09.18.13.27a2.29,2.29,0,0,1,.1.23l.09.23q.13.34.24.72c0,.1.06.21.08.31s.1.45.14.68a8.65,8.65,0,0,1-.28,4,8.09,8.09,0,0,1-.38,1h0l0,.08-.14.3a1.62,1.62,0,0,1-.1.18l-.08.15c0,.08-.09.16-.14.23a9.92,9.92,0,0,1-.91,1.24l-.21.22-.18.19c-.19.19-.39.37-.59.54l-.18.15a9,9,0,0,1-.81.56l-.18.11-.15.08a7.14,7.14,0,0,1-.73.37l-.5.2-.26.09-.27.08-.27.08a7.45,7.45,0,0,1-.82.17l-.1,0a8.72,8.72,0,0,1-9.67-11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M201.94,150.1l-.85,1.44a7.66,7.66,0,0,0-.22,7.54L232,228.83l10.91-1.76,2,3.68a7.85,7.85,0,0,0,10.66,3.09l23.76-12.65a7.47,7.47,0,0,0,3.82-2l38.15-20.31a7.91,7.91,0,0,0,2.23-1.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M246,112.12a13,13,0,0,0-6.55-5L239,107a13.18,13.18,0,0,0-6.44-.31,12.53,12.53,0,0,0-3.19,1.09,13.12,13.12,0,0,0-6.81,8.14l-.09.31A13.12,13.12,0,1,0,246,112.12Zm-10,14.13a9.4,9.4,0,0,1-6.87-2.07,14.07,14.07,0,0,0,6.47-4.93c.1-.13.2-.28.29-.42,0,.09.09.18.13.27a2.29,2.29,0,0,1,.1.23l.09.23q.13.34.24.72c0,.1.06.21.08.31s.1.45.14.68a8.65,8.65,0,0,1-.28,4,8.09,8.09,0,0,1-.38,1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M324.67,189.25,280,105.36a7.67,7.67,0,0,0-6.38-4l-36-2-7.46-.42a8.1,8.1,0,0,0-3,.39,8.19,8.19,0,0,0-4.47,3.58l-3.36,5.66h0l-1.16,2-17.71,29.84a7.68,7.68,0,0,0-.23,7.54l1.45,2.72.27.51,40.51,76.09.47.89,2,3.68a7.84,7.84,0,0,0,10.66,3.08l23.76-12.64,3.82-2,38.15-20.31a8.06,8.06,0,0,0,2.23-1.74A7.76,7.76,0,0,0,324.67,189.25Zm-82.75-78.78a9.34,9.34,0,0,1,1,1.29l.07.11c.12.2.24.4.35.61a9.38,9.38,0,0,1-.85,10.14,9.25,9.25,0,0,1-3,2.57,9.47,9.47,0,0,1-3.11,1l-.38,0h0a9.4,9.4,0,0,1-6.87-2.07h0l-.11-.08-.11-.1h0l-.28-.26-.36-.36a9.35,9.35,0,0,1-2.53-7.52c0-.22.06-.44.1-.65a.29.29,0,0,1,0-.09,7.58,7.58,0,0,1,.23-.94,9.35,9.35,0,0,1,1.17-2.5,9.57,9.57,0,0,1,2-2.19,9.86,9.86,0,0,1,1.38-.89,9.37,9.37,0,0,1,2.22-.84,8.79,8.79,0,0,1,1.75-.25,9.45,9.45,0,0,1,4.39.86A9.28,9.28,0,0,1,241.92,110.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236.37,125.24a8.09,8.09,0,0,1-.38,1h0a9.4,9.4,0,0,1-6.87-2.07,14.07,14.07,0,0,0,6.47-4.93c.1-.13.2-.28.29-.42,0,.09.09.18.13.27a2.29,2.29,0,0,1,.1.23l.09.23q.13.34.24.72c0,.1.06.21.08.31s.1.45.14.68A8.65,8.65,0,0,1,236.37,125.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M254.46,203.28a4,4,0,0,1-3.84-5.2L269,138.62a4,4,0,1,1,7.67,2.36L258.3,200.45A4,4,0,0,1,254.46,203.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M285,191.29a14.45,14.45,0,1,1,6.76-1.69A14.47,14.47,0,0,1,285,191.29Zm0-20.88a6.46,6.46,0,0,0-3,.76h0a6.33,6.33,0,1,0,3-.76Zm-4.89-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M242.47,177.19A14.46,14.46,0,1,1,256.27,167a14.43,14.43,0,0,1-13.8,10.23Zm0-20.87a6.42,6.42,0,0,0-3,.75h0a6.43,6.43,0,1,0,4.89-.47A6.34,6.34,0,0,0,242.44,156.32Zm-4.89-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M239,107c0-.09,0-.17,0-.26a27.72,27.72,0,0,0-1.38-7.43,31.34,31.34,0,0,0-2.6-5.76c-4.87-8.44-12.91-13.46-20.28-13.46a14.4,14.4,0,0,0-7.3,1.91c-8.67,5-10.36,18.28-3.79,29.66a30.67,30.67,0,0,0,4.72,6.22h0l6.94-5.93.42-.35a20.57,20.57,0,0,1-3.75-4.76,18.5,18.5,0,0,1-2.6-11.18c.19-1.47.81-4.13,2.86-5.32a4.92,4.92,0,0,1,2.49-.61c3.35,0,8.51,2.7,11.94,8.64.17.3.34.61.49.91h0a20,20,0,0,1,2,6h0c.05.34.1.67.13,1a14.21,14.21,0,0,1,.07,1.45,12.28,12.28,0,0,1-.1,1.73v0a8.58,8.58,0,0,1-1.07,3.36,8.31,8.31,0,0,1-.8,1.09,4.18,4.18,0,0,1-1,.87l-.28.15-.28.12a.29.29,0,0,0,0,.09c0,.21-.08.43-.1.65a9.35,9.35,0,0,0,2.53,7.52l.36.36.28.26h0l.11.09.11.09h0a14.07,14.07,0,0,0,6.47-4.93c.1-.13.2-.28.29-.42a18.45,18.45,0,0,0,3-8.63c0-.31.06-.62.08-.93s0-.61,0-.91h0C239,107.9,239,107.43,239,107Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "paw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M391.71,130a12.47,12.47,0,0,1,3.94,3.39,16.43,16.43,0,0,1,1.66,3.23,31.35,31.35,0,0,1,1.82,7.33,46.19,46.19,0,0,1,0,12.81,24.32,24.32,0,0,1-1.57,6.07,11.53,11.53,0,0,1-1.17,2.12,4.65,4.65,0,0,1-3.33,2,8.56,8.56,0,0,1-4.86-.74,16.82,16.82,0,0,1-4.39-3c-1.71-1.56-3.22-3.31-4.78-5-.46-.51-.95-1-1.42-1.48a6.08,6.08,0,0,0-2.68-1.62l-4.89-1.42a32.17,32.17,0,0,1-5.62-2.09,12,12,0,0,1-4-3.06,7.84,7.84,0,0,1-1.66-3.66,4.28,4.28,0,0,1,.46-2.61,11.78,11.78,0,0,1,2.51-3.31,31.72,31.72,0,0,1,6.45-4.76,45.57,45.57,0,0,1,11.87-4.88,23.69,23.69,0,0,1,6.33-.8,10.27,10.27,0,0,1,4,.78,8.46,8.46,0,0,1,.94.5A4.36,4.36,0,0,1,391.71,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M414.68,127.92a15.38,15.38,0,0,1-3,3.41,17.9,17.9,0,0,1-4.89,3,8.24,8.24,0,0,1-2.86.66,5.26,5.26,0,0,1-4.73-2.41,7.86,7.86,0,0,1-1.35-4.33,11.24,11.24,0,0,1,1.73-6.6,10.12,10.12,0,0,1,6.18-4.45,12.44,12.44,0,0,1,5.36-.31,7.6,7.6,0,0,1,2.72,1,5.31,5.31,0,0,1,2.59,4.47,9,9,0,0,1-1.15,4.64l-.27.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M384.22,109a10.29,10.29,0,0,1,3.72-3.73,5.44,5.44,0,0,1,4.7-.4,6.29,6.29,0,0,1,2.74,2.09,12,12,0,0,1,2.47,9.51,9.76,9.76,0,0,1-2.55,5,11.17,11.17,0,0,1-5.12,3.25,7,7,0,0,1-4.09.07,5.24,5.24,0,0,1-3.56-3.39,10.9,10.9,0,0,1-.56-4.28,17.89,17.89,0,0,1,1.43-6.52C383.69,110,384,109.35,384.22,109Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M377.23,125.64a7.56,7.56,0,0,1-3.51,3,5.33,5.33,0,0,1-6.25-1.49,12.24,12.24,0,0,1-2.3-3.8,11.78,11.78,0,0,1-.94-4.65,7.28,7.28,0,0,1,1.2-4.15,4.91,4.91,0,0,1,4.45-2.23,7.46,7.46,0,0,1,3.17.89,10.77,10.77,0,0,1,4.42,4,7.39,7.39,0,0,1,.66,6.56c-.23.65-.56,1.27-.84,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M415.58,139.47a8.53,8.53,0,0,1,2.75,2.79,4.94,4.94,0,0,1-.13,5.34,7.3,7.3,0,0,1-3.37,2.82,13.1,13.1,0,0,1-8.44.75,5.47,5.47,0,0,1-2.86-1.58,5.36,5.36,0,0,1-1.44-4.53,8.17,8.17,0,0,1,5.41-6.95,7.49,7.49,0,0,1,4.77-.11A12.06,12.06,0,0,1,415.58,139.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "paw-2",
    "data-name": "paw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M121,94.64a10.27,10.27,0,0,1,3.81-2,14.42,14.42,0,0,1,3-.32,26.58,26.58,0,0,1,6.22.8A38.57,38.57,0,0,1,144,96.92a19.67,19.67,0,0,1,4.22,3,8.58,8.58,0,0,1,1.29,1.53,3.88,3.88,0,0,1,.56,3.19,7.23,7.23,0,0,1-2,3.54,13.93,13.93,0,0,1-3.68,2.48c-1.72.86-3.53,1.5-5.31,2.2-.53.21-1.05.44-1.58.66a4.92,4.92,0,0,0-2,1.59c-.86,1.11-1.72,2.23-2.57,3.35a27.94,27.94,0,0,1-3.31,3.73,9.86,9.86,0,0,1-3.58,2.19,6.6,6.6,0,0,1-3.33.19,3.5,3.5,0,0,1-1.88-1.15,9.84,9.84,0,0,1-1.81-2.93,27,27,0,0,1-1.75-6.43,38,38,0,0,1-.21-10.65,19.47,19.47,0,0,1,1.28-5.14,8.61,8.61,0,0,1,1.8-2.85,7.32,7.32,0,0,1,.67-.58C121,94.64,120.69,94.88,121,94.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M126.31,76.23A12.2,12.2,0,0,1,128,79.6a14.61,14.61,0,0,1,.85,4.68,6.8,6.8,0,0,1-.34,2.41,4.39,4.39,0,0,1-3.29,2.94,6.53,6.53,0,0,1-3.76-.25,9.39,9.39,0,0,1-4.59-3.32,8.48,8.48,0,0,1-1.59-6.13,10.33,10.33,0,0,1,1.37-4.24,6.22,6.22,0,0,1,1.58-1.81,4.4,4.4,0,0,1,4.24-.66,7.42,7.42,0,0,1,3.24,2.28l.3.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M102.52,94.13a8.45,8.45,0,0,1-1.77-4,4.52,4.52,0,0,1,1.1-3.76,5.16,5.16,0,0,1,2.44-1.49,9.92,9.92,0,0,1,8.1.94,8.09,8.09,0,0,1,3.14,3.49,9.19,9.19,0,0,1,1,4.94,5.88,5.88,0,0,1-1.18,3.19,4.36,4.36,0,0,1-3.69,1.74,9.15,9.15,0,0,1-3.48-.86,14.89,14.89,0,0,1-4.62-3.06C103.12,94.84,102.73,94.37,102.52,94.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M113.3,104.54a6.33,6.33,0,0,1,1.29,3.62,4.45,4.45,0,0,1-3,4.4,10.57,10.57,0,0,1-3.64.64,9.71,9.71,0,0,1-3.88-.67,5.92,5.92,0,0,1-2.85-2.18,4.05,4.05,0,0,1-.39-4.11,6.13,6.13,0,0,1,1.64-2.19,8.94,8.94,0,0,1,4.39-2.23,6.12,6.12,0,0,1,5.28,1.45c.43.38.81.82,1.22,1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M135.53,79a7,7,0,0,1,3-1.29,4.1,4.1,0,0,1,4.09,1.7,6,6,0,0,1,1.17,3.46,10.87,10.87,0,0,1-2,6.76,4.54,4.54,0,0,1-2.08,1.74,4.46,4.46,0,0,1-4-.25A6.78,6.78,0,0,1,132,84.85a6.22,6.22,0,0,1,1.35-3.73A9.78,9.78,0,0,1,135.53,79Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "paw-3",
    "data-name": "paw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M310.47,46.39a7.37,7.37,0,0,1,2.81,1,9.69,9.69,0,0,1,1.56,1.37,18.38,18.38,0,0,1,2.49,3.52A26.53,26.53,0,0,1,320,59.08a13.75,13.75,0,0,1,.43,3.55,6.27,6.27,0,0,1-.18,1.37,2.66,2.66,0,0,1-1.35,1.77,4.94,4.94,0,0,1-2.74.62,9.55,9.55,0,0,1-3-.71c-1.24-.47-2.4-1.09-3.59-1.66-.35-.18-.71-.33-1.06-.5a3.46,3.46,0,0,0-1.77-.3l-2.89.26a18.71,18.71,0,0,1-3.43.07,6.76,6.76,0,0,1-2.77-.8,4.44,4.44,0,0,1-1.65-1.6,2.38,2.38,0,0,1-.3-1.48,6.86,6.86,0,0,1,.64-2.28,18.41,18.41,0,0,1,2.45-3.88,26,26,0,0,1,5.29-5.07,13.65,13.65,0,0,1,3.2-1.75,5.94,5.94,0,0,1,2.28-.41,4.22,4.22,0,0,1,.61.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M322.26,40.5a8.54,8.54,0,0,1-.9,2.44,10.06,10.06,0,0,1-2,2.61,4.66,4.66,0,0,1-1.38,1,3,3,0,0,1-3-.3,4.53,4.53,0,0,1-1.62-2,6.43,6.43,0,0,1-.46-3.87,5.84,5.84,0,0,1,2.36-3.66,7.18,7.18,0,0,1,2.79-1.28,4.36,4.36,0,0,1,1.65,0A3,3,0,0,1,322,37.16a5.13,5.13,0,0,1,.35,2.71c0,.1,0,.21,0,.31S322.28,40.39,322.26,40.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M302.11,36.79A5.83,5.83,0,0,1,303.32,34a3.12,3.12,0,0,1,2.41-1.2,3.64,3.64,0,0,1,1.9.54,6.85,6.85,0,0,1,3.29,4.55,5.52,5.52,0,0,1-.3,3.21,6.35,6.35,0,0,1-2.05,2.8,4.07,4.07,0,0,1-2.16.89,3,3,0,0,1-2.6-1.06,6.44,6.44,0,0,1-1.19-2.16,10.11,10.11,0,0,1-.6-3.77C302,37.42,302.09,37,302.11,36.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M301.86,47.09a4.3,4.3,0,0,1-1.23,2.34,3.05,3.05,0,0,1-3.64.51,7.23,7.23,0,0,1-2-1.54,6.9,6.9,0,0,1-1.46-2.27,4.15,4.15,0,0,1-.23-2.46,2.82,2.82,0,0,1,1.91-2.12,4.37,4.37,0,0,1,1.87-.19,6.19,6.19,0,0,1,3.17,1.19A4.2,4.2,0,0,1,302,45.9c0,.4,0,.79-.05,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M325.15,46.45a4.83,4.83,0,0,1,2,.92,2.8,2.8,0,0,1,1.05,2.86A4.25,4.25,0,0,1,327,52.44a7.46,7.46,0,0,1-4.33,2.15,3.11,3.11,0,0,1-1.85-.24,3.06,3.06,0,0,1-1.71-2.11,4.67,4.67,0,0,1,1.42-4.83,4.32,4.32,0,0,1,2.52-1A7.21,7.21,0,0,1,325.15,46.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsPopup);
export default __webpack_public_path__ + "static/media/benefits_popup.2be7384012827843ffad2a696fa9ff40.svg";
export { ForwardRef as ReactComponent };